export const ConfigMantenedorProveedor = {
   barraBusqueda: {
      criterios: ["Razon Social", "Rut", "Giro", "Ciudad", "Comuna"],
      criteriosKeys: ["razonSocial", "rut", "giro", "ciudad", "comuna"],
      criterioPrincipal: "Razon Social",
   },
   table: {
      title: "Proveedores",
      add: "Agregar Proveedor",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
